import { render, staticRenderFns } from "./PracticeLocationsPage.vue?vue&type=template&id=3047cd68&scoped=true"
import script from "./PracticeLocationsPage.vue?vue&type=script&lang=js"
export * from "./PracticeLocationsPage.vue?vue&type=script&lang=js"
import style0 from "./PracticeLocationsPage.vue?vue&type=style&index=0&id=3047cd68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3047cd68",
  null
  
)

export default component.exports